import React from 'react'

import BulkFileUpload from './bulkDisputeFileUpload';
import BulkDisputeTable from './bulkDisputesTable';
import Breadcrumbs from 'react-breadcrumbs';
import PageTitle from '../../common/pageTitle';

import Constants from '../../../configurations/constants';
import Util from '../../../util/util';
import Toaster from 'toastr';
import DisputesAPI from '../../../api/DisputesApi';
import Messages from '../../../configurations/messages';
import Spinner from 'react-spinkit';


class BulkDisputePage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            disputesBatches: [],
            totalCount: 0,
            loading: false,
            pages: 0,
            pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
            pageNum: 0, //Zero based index
            filterParams: null
        };
        this.uploadBatchFile = this.uploadBatchFile.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.onTableChange = this.onTableChange.bind(this);
    }
    componentDidMount() {
        //Load data on mount
       this.reloadTable();
    }


    handleFileUpload(params) {

        let file = params.batchFile;
        if (!file) {
            Toaster.error(`${Messages.ERROR_BATCH_NO_FILE_SELECTED}`)
            //Reset state 
            this.setState({ fileUploadText: '' })
            return;
        }
        if (file.size > Constants.MAXIMUM_BATCH_FILE_SIZE) {
            Toaster.error(`${Messages.ERROR_FILE_TOO_LARGE} - ${Math.floor(Constants.MAXIMUM_BATCH_FILE_SIZE / 1024)}KB`, `${Messages.ERROR_FILE_TOO_LARGE_TITLE} - ${file.name}`);
            return false;
        }


        var fileReader = new FileReader();
        fileReader.onloadend = (e) => {
            
            var fileArray = (new Uint8Array(e.target.result))
            var arr = fileArray.subarray(0, 4);
            var header = "";
            for (var i = 0; i < arr.length; i++) {
                header += arr[i].toString(16);
            }
            console.log(header);
            let type = "unknown";
            // Check the file signature against known types
            switch (header) {
                case "d0cf11e0":
                    type = "xls";
                    break;
                case "504b34":
                case "504b56":
                case "504b78":
                case "504b0304":
                case "504b0506":
                case "504b0708":
                    type = "xlsx"; //Not a solid check, this could be another archive format e.g zip, jar 
                    break;
            }
            if (type === "unknown") {
                Toaster.error(`${Messages.ERROR_BATCH_INVALID_FILE_TYPE}`, `${Messages.ERROR_BATCH_INVALID_FILE_TYPE_TITLE} - ${file.name}`);
                return;
            }
            //Convert to base 64 and add to selected
            let base64String = btoa(fileArray.reduce((data, byte) =>  data  + String.fromCharCode(byte), ''));
            
            //Remve 'batchFile' from param
            delete params.batchFile;

            //Add base64 encoded file
            params.base64EncodedBatchFile = base64String;

            this.uploadBatchFile(params);
        };
        fileReader.readAsArrayBuffer(file);

    }
    onTableChange(state, instance) {
        let pageSize = instance.state.pageSize;
        let pageNum = (instance.state.page); //table page  - Zero based index
        this.setState({ pageSize: pageSize, pageNum: pageNum });
        if (this.state.filterParams) {
            let params = Util.clone(this.state.filterParams);
            params.pageSize = pageSize;
            params.pageNum = pageNum + 1;

            this.loadTableData(params);
        }

    }
    uploadBatchFile(params)
    {
        this.setState({uploading : true});
        DisputesAPI
            .createBatchDispute(params)
            .then((response) => {
                Toaster.success(Messages.SUCCESS_DISPUTE_BATCH_UPLOAD);
                this.setState({ uploading: false });
                this.reloadTable();
            })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${Messages.ERROR_DISPUTE_BATCH_UPLOAD} - ${error.data ? error.data.description : error.statusText}`, `${error.status}`);
                this.setState({ uploading: false });
            });
        
    }
    loadTableData(params, resetPageNumber) {
        //Reset states 
        let stateUpdate = { loading: true, disputesBatches: [] };
        if (resetPageNumber) {
            stateUpdate.pageNum = 0;
            params.pageNum = 1;
        }
        this.setState(stateUpdate);
        params.pageSize = params.pageSize || this.state.pageSize;
        params.pageNum = params.pageNum || (this.state.pageNum + 1);


        DisputesAPI.findDisputesBatches(params)
            .then((response) => {
                let data = response.data.content;
                let totalCount = response.data.count;
                let pages = totalCount ? Math.ceil(totalCount / (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)) : 0;
                if (data.length === 0)
                    Toaster.warning("No records found.", "Batches")

                this.setState({ disputesBatches: data, loading: false, filterParams: params, totalCount: totalCount, pages: pages });
            })
            .catch((error) => {
                console.log(error);
                Toaster.error(`${Messages.ERROR_DISPUTES_SEARCH} - ${error.data ? error.data.description : error.statusText}`, `${Messages.ERROR_DISPUTES_SEARCH_TITLE} - ${error.status}`);
                this.setState({ loading: false });
            });
    }
    render() {
        return (
            <div>
                <div id="page-breadcrumb" className="breadcrumb-container">
                    <Breadcrumbs routes={this.props.routes}
                        params={this.props.params} />
                </div>
                <PageTitle title="Dispute Batches" />
                <div className="bulk-files-container">
                    <BulkFileUpload onUpload={this.handleFileUpload} />
                    {this.state.uploading && 
                    <div className="full-loading">
                        <div className="loader">
                            <Spinner name="three-bounce" color="blue"/>
                        </div>
                    </div>
                    }
                </div>    
                <BulkDisputeTable
                
                    loading={this.state.loading}
                    onTableChange={this.onTableChange}
                    page={this.state.pageNum}
                    pages={this.state.pages}
                    defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
                    disputesBatches={this.state.disputesBatches} />
            </div>
        )
    }
    reloadTable(){
       this.loadTableData({ pageSize: this.state.pageSize });
    }


}

export default BulkDisputePage;


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/bulkDisputes/bulkDisputesPage.js